module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/c1f1b4453ba208b946f1bebe5cd46c25.svg";